/* ================================================================
   INKPRINT — theme.js (Restored)
   Production-ready interactive features
   ================================================================ */

document.addEventListener('DOMContentLoaded', () => {

    /* ── Header scroll effect ── */
    const header = document.getElementById('main-header');
    window.addEventListener('scroll', () => {
        header.classList.toggle('scrolled', window.scrollY > 60);
        document.getElementById('backTop')?.classList.toggle('visible', window.scrollY > 400);
    }, { passive: true });

    /* ── Back to top ── */
    document.getElementById('backTop')?.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    /* ── Hero Slider ── */
    const slides    = document.querySelectorAll('.slide');
    const dots      = document.querySelectorAll('.dot');
    let currentSlide = 0;
    let sliderTimer;

    function goToSlide(index) {
        if (!slides.length) return;
        slides[currentSlide].classList.remove('active');
        dots[currentSlide]?.classList.remove('active');
        currentSlide = (index + slides.length) % slides.length;
        slides[currentSlide].classList.add('active');
        dots[currentSlide]?.classList.add('active');
    }

    function startAutoPlay() {
        if (!slides.length) return;
        sliderTimer = setInterval(() => goToSlide(currentSlide + 1), 4500);
    }

    document.getElementById('slideNext')?.addEventListener('click', () => {
        clearInterval(sliderTimer);
        goToSlide(currentSlide + 1);
        startAutoPlay();
    });
    document.getElementById('slidePrev')?.addEventListener('click', () => {
        clearInterval(sliderTimer);
        goToSlide(currentSlide - 1);
        startAutoPlay();
    });
    dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
            clearInterval(sliderTimer);
            goToSlide(i);
            startAutoPlay();
        });
    });
    startAutoPlay();

    /* ── Cart Count (Shopify API) ── */
    function updateCartCount() {
        fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
                document.querySelectorAll('.cart-count').forEach(el => {
                    el.textContent = cart.item_count;
                });
            });
    }
    // updateCartCount(); // Handled by Shopify on page load usually

    /* ── Wishlist heart toggle ── */
    document.querySelectorAll('.pa-btn[title="Wishlist"]').forEach(btn => {
        btn.addEventListener('click', () => {
            const icon = btn.querySelector('i');
            const isWished = icon.classList.contains('fa-solid');
            icon.classList.toggle('fa-solid', !isWished);
            icon.classList.toggle('fa-regular', isWished);
            if (!isWished) { icon.style.color = '#ef4444'; }
            else { icon.style.color = ''; }
        });
    });

    /* ── Mobile hamburger (Fixed) ── */
    const hamburger = document.getElementById('hamburger');
    const drawer    = document.getElementById('mobile-drawer');
    const overlay   = document.getElementById('mobile-overlay');
    const closeBtn  = document.getElementById('drawer-close');

    function openDrawer() {
        drawer?.classList.add('active');
        overlay?.classList.add('active');
        document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
        drawer?.classList.remove('active');
        overlay?.classList.remove('active');
        document.body.style.overflow = '';
    }

    hamburger?.addEventListener('click', openDrawer);
    closeBtn?.addEventListener('click', closeDrawer);
    overlay?.addEventListener('click', closeDrawer);

    /* ── Intersection Observer – subtle fade-in ── */
    const revealObs = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.style.opacity = '1';
                entry.target.style.transform = 'translateY(0)';
                revealObs.unobserve(entry.target);
            }
        });
    }, { threshold: 0.08, rootMargin: '0px 0px -50px 0px' });

    document.querySelectorAll('.product-card, .article-card, .combo-card, .promo-card, .material-card, .trust-item').forEach(el => {
        el.style.cssText += 'opacity:0; transform:translateY(24px); transition: opacity .55s ease, transform .55s ease, box-shadow .25s ease;';
        revealObs.observe(el);
    });

    /* ── Product gallery image switcher ── */
    const mainImg = document.getElementById('ProductMainImage');
    document.querySelectorAll('.gallery-thumb').forEach(thumb => {
        thumb.addEventListener('click', () => {
            const newUrl = thumb.getAttribute('data-image-url');
            if (mainImg) mainImg.src = newUrl;
            document.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
            thumb.classList.add('active');
        });
    });

    /* ── Quantity control ── */
    document.querySelectorAll('.qty-control').forEach(ctrl => {
        const minus = ctrl.querySelector('.qty-btn.minus') || ctrl.querySelector('.qty-btn:first-child');
        const plus  = ctrl.querySelector('.qty-btn.plus') || ctrl.querySelector('.qty-btn:nth-child(3)');
        const input = ctrl.querySelector('input') || ctrl.querySelector('.qty-val');
        
        minus?.addEventListener('click', () => {
            let val = parseInt(input.value || input.textContent);
            if (val > 1) {
                if (input.tagName === 'INPUT') input.value = val - 1;
                else input.textContent = val - 1;
            }
        });
        plus?.addEventListener('click', () => {
            let val = parseInt(input.value || input.textContent);
            if (input.tagName === 'INPUT') input.value = val + 1;
            else input.textContent = val + 1;
        });
    });

    /* ── Accordion logic (FAQs) ── */
    document.querySelectorAll('.accordion-header').forEach(header => {
        header.addEventListener('click', () => {
            const item = header.parentElement;
            const body = header.nextElementSibling;
            const isOpen = header.classList.contains('open');
            
            // Close other open items (optional, but cleaner)
            document.querySelectorAll('.accordion-header').forEach(h => {
                h.classList.remove('open');
                h.nextElementSibling.style.display = 'none';
            });

            if (!isOpen) {
                header.classList.add('open');
                body.style.display = 'block';
            }
        });
    });


});
